// extracted by mini-css-extract-plugin
export default {"component":"WidgetLongerDuration_component__X7-Hd","col":"WidgetLongerDuration_col__4YQ3M"};